// Target end point api actions
export const FETCH_JOB_LIST_REQUEST = "FETCH_JOB_LIST_REQUEST";
export const FETCH_JOB_LIST_SUCCESS = "FETCH_JOB_LIST_SUCCESS";
export const FETCH_JOB_LIST_FAILURE = "FETCH_JOB_LIST_FAILURE";
